export default "__VITE_ASSET__CQjee2j1__"